import React from 'react';

import { QueryResponse } from 'api/queries/activityCompletionPlan.query';
import { ISingleSmallCardResponse } from 'api/queries/getListFilteredCards.query';

import { ITab } from 'components/common/CustomizedTabs/CustomizedTabs';

import TableTab from 'components/widgets/ActivityCompletionPlan/TableTab/tableTab';

export type IActivityCompletionList = {
    activity_id: string;
    activity_name: string;
    activity_status: string;
    activity_type: string;
    card_board: ISingleSmallCardResponse;
    days_to_target: number;
    finish_date: number;
    finish_date_change: number;
    blocking: boolean;
    completed: boolean;
    delaying: boolean;
    narrative: string;
    schedule: boolean;
    parentName: string;
    path_length: number;
    remaining_duration: number;
    succeeding_activities: number;
    successors_in_fragnet: number;
    successors_num: number;
    start_date: number;
};

export const projectActivitiesCompletionPlanSegmentFilter: { [k in TKeys]: string | null } = {
    blocking: 'BLOCKING_FILTER',
    delaying: 'DELAYING_FILTER',
    schedule: 'ON_SCHEDULE_FILTER',
    completed: 'COMPLETED_FILTER',
    all: null,
};

export type TKeys = 'blocking' | 'delaying' | 'schedule' | 'completed' | 'all';

export const generateTabs = ({ data }: { data: QueryResponse | undefined }): ITab<TKeys>[] => {
    if (data) {
        return [
            {
                value: 'blocking',
                label: <TableTab title={`Blockers (${data.blokersCount})`} className={`red`} />,
            },
            {
                value: 'delaying',
                label: <TableTab title={`Delayed (${data.delaydCount})`} className={`yellow`} />,
            },

            {
                value: 'schedule',
                label: <TableTab title={`On Schedule (${data.onScheduleCount})`} />,
            },

            {
                value: 'completed',
                label: <TableTab title={`Completed (${data.completedCount})`} />,
            },
            {
                value: 'all',
                label: <TableTab title={`All (${data.allCount})`} />,
            },
        ];
    }
    return [];
};

export const getScheduleAdherenceColorClass = (value: number | undefined) => {
    if (!value) return '';
    if (value < 0.9) {
        return 'red';
    } else if (value >= 0.9 && value < 1) {
        return 'amber';
    } else if (value >= 1) {
        return 'green';
    }
    return 'red';
};
